//Vendor
import gsap from 'gsap'
import axios from 'axios'
import Mapbox from 'Scripts/components/Mapbox'
//Custom
import Page from 'Scripts/classes/Page'
//Class
export default class Map extends Page {
  constructor() {
    super(
      'map',
      {
        container: '.map',
        elements: {         
          pdv: '#pdv',
          map: '#map'  
        }
      })

    //Methods
    this.init()

  }  

  init(){
    // gsap.set(this.elements.pdv, { display: 'initial' })
    this.initMapbox()
  }

  //Map functions
  async initMapbox() {
    // https://www.madmounapp.ma/wp-json/madmoun/v1/pdv/activite/1380
    // await axios.get(`${process.env.MAP_API}/pdv/agent`)

    if (!this.elements.map) return
    await axios.get(`${process.env.MAP_API}/pdv/activite/1380`) // agences agéées
      .then((response) => {
        // console.log(response)
        new Mapbox({
          selector: 'map',
          zoom: 6,
          center: [-7.6570322, 33.5722678],
          data: response.data
        })

      }).catch((error) => {
        console.log(error)
      })
  }


  /**
  * Animations.
  */
  show() {
    return super.show()
  }

  hide() {
    return super.hide()
  }

}


